export default __webpack_public_path__ + "static/media/pelvic-prolapse.1b515c0d.png";